/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFilesList } from "../../funcs/llmFilesList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListFilesRequest$inboundSchema,
};

export const tool$llmFilesList: ToolDefinition<typeof args> = {
  name: "llm-files-list",
  description: `List files

Returns a list of files that have been uploaded.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFilesList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
